import classNames from 'classnames'
import React from 'react'
import { getOrganizationLogoUrl } from 'scenes/Dashboard/data/digitalPresences/helpers'
import { Organization, OrganizationSource } from 'scenes/Dashboard/data/organizations/types'
import { makeStyles } from 'tss-react/mui'

import { Avatar, Theme } from '@mui/material'

export type OrganizationLogoProps = {
  size: string
  className?: string
  organization?: Partial<Organization>
  source?: OrganizationSource
  onClick?: () => void
}

export const OrganizationLogo = React.memo(({ size, className, organization = {}, onClick }: OrganizationLogoProps) => {
  const { classes } = useStyles()
  const organizationName = organization.name || 'Default'
  const logoUrl = getOrganizationLogoUrl(organization)

  return (
    <div className={classNames(classes.container, className)}>
      <Avatar
        variant="rounded"
        style={{ height: size, width: size }}
        alt={`${organizationName} logo`}
        src={logoUrl}
        className={classes.logo}
        onClick={onClick}
      />
    </div>
  )
})

OrganizationLogo.displayName = 'OrganizationLogo'

export const useStyles = makeStyles()(({ palette, spacing }: Theme) => {
  return {
    container: {
      display: 'flex',
      position: 'relative',
      flex: '0 0 auto',
    },
    logo: {
      border: `1px solid ${palette.grey[400]}`,
    },
    iconInbound: {
      width: spacing(2.5),
      height: spacing(2.5),
    },
    iconOutbound: {
      width: spacing(2.25),
      height: spacing(2.25),
    },
    sourceInboundHighlight: {
      position: 'absolute',
      bottom: 3,
      right: 0,
      transform: 'translate(25%, 25%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: spacing(3.5),
      height: spacing(3.5),
      borderRadius: '50%',
      fontWeight: 'bold',
      color: 'white',
      userSelect: 'none',
      backgroundColor: palette.extra.positive,
    },
    sourceOutboundHighlight: {
      position: 'absolute',
      bottom: 3,
      right: 0,
      transform: 'translate(25%, 25%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: spacing(3.5),
      height: spacing(3.5),
      borderRadius: '50%',
      fontWeight: 'bold',
      color: 'white',
      userSelect: 'none',
      backgroundColor: palette.extra.neutral,
    },
  }
})

export default OrganizationLogo
